/* Collectors Guild: the ink icons come alive. Two SVG filters, one engine.
   Boil: every icon's outline wobbles as if redrawn by hand, cycling three noise frames a few times a second (the same
   boil as the ANNIVERSARY lettering in guild-editorial-characters.js). Fuzz: hovering or focusing a guide row tears its
   big numeral sideways, a question tears its icon instead (Prav's fuzzy-text signal fault: sideways only, re-scrambled
   about 15 times a second). The words never move.
   Off entirely under reduced motion; paused while no icon is on screen and on a hidden tab. html[data-cg-ink] is set
   here, so no script means still, sharp drawings. Taste numbers: window.CollectorsGuildInk.tune (live). */
(() => {
  if (window.CollectorsGuildInk) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const targets = [...document.querySelectorAll('.cg-ink-boil, [data-cg-ink-observe], [data-cg-ink-host], .shopify-policy__title h1')];
  if (!targets.length || !('IntersectionObserver' in window)) return;
  // boil: outline wobble in icon units (a 64-unit drawing); boilFps: redraws a second. fuzz: numeral tear in px at
  // 50px type (icons get the same tear in their own units); fuzzFps: re-scrambles a second.
  const tune = { boil: 2.2, boilFps: 6, fuzz: 5, fuzzFps: 15 };

  const defs = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  defs.setAttribute('aria-hidden', 'true');
  defs.setAttribute('focusable', 'false');
  defs.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
  defs.innerHTML = '<filter id="cg-ink-boil" x="-10%" y="-10%" width="120%" height="120%"><feTurbulence type="fractalNoise" baseFrequency="0.06" numOctaves="1" seed="1"/><feDisplacementMap in="SourceGraphic" scale="2.2" xChannelSelector="R" yChannelSelector="G"/></filter>'
    // Green flattened to 0.5 so the tear is sideways only (fuzzy-text rule 3).
    + '<filter id="cg-ink-fuzz" x="-12%" y="-30%" width="124%" height="160%" color-interpolation-filters="sRGB"><feTurbulence type="fractalNoise" baseFrequency="0.012 0.92" numOctaves="1" seed="2" result="n"/><feColorMatrix in="n" type="matrix" result="nx" values="1 0 0 0 0 0 0 0 0 0.5 0 0 1 0 0 0 0 0 0 1"/><feDisplacementMap in="SourceGraphic" in2="nx" scale="5" xChannelSelector="R" yChannelSelector="G"/></filter>';
  document.body.append(defs);
  const [boilNoise, boilMap] = defs.querySelector('#cg-ink-boil').children;
  const fuzzNoise = defs.querySelector('#cg-ink-fuzz feTurbulence'), fuzzMap = defs.querySelector('#cg-ink-fuzz feDisplacementMap');
  if (!reduce.matches) document.documentElement.setAttribute('data-cg-ink', '');

  let frame = 0, lastBoil = 0, lastFuzz = 0, step = 0, fuzzing = null;
  const seen = new Set();
  const running = () => !reduce.matches && !document.hidden && seen.size > 0;
  const tick = t => {
    frame = 0;
    if (!running()) return;
    frame = requestAnimationFrame(tick);
    if (t - lastBoil >= 1000 / tune.boilFps) {
      lastBoil = t;
      step = (step + 1) % 3;
      boilNoise.setAttribute('seed', String(1 + step));
      boilMap.setAttribute('scale', String(tune.boil));
    }
    if (fuzzing && t - lastFuzz >= 1000 / tune.fuzzFps) {
      lastFuzz = t;
      fuzzNoise.setAttribute('seed', String((Math.random() * 9999) | 0));
      fuzzMap.setAttribute('scale', (tune.fuzz * (.55 + Math.random() * .9)).toFixed(2));
    }
  };
  const wake = () => { if (!frame && running()) frame = requestAnimationFrame(tick); };
  const sleep = () => { if (frame && !running()) { cancelAnimationFrame(frame); frame = 0; } };

  const io = new IntersectionObserver(entries => {
    for (const entry of entries) entry.isIntersecting ? seen.add(entry.target) : seen.delete(entry.target);
    seen.size ? wake() : sleep();
  }, { rootMargin: '10% 0px' });
  targets.forEach(target => io.observe(target));
  document.addEventListener('visibilitychange', () => { if (document.hidden) sleep(); else { lastBoil = lastFuzz = 0; wake(); } });

  const fuzz = host => {
    if (reduce.matches) host = null;
    if (fuzzing === host) return;
    fuzzing?.classList.remove('is-fuzz');
    fuzzing = host;
    if (host) { host.classList.add('is-fuzz'); lastFuzz = 0; wake(); }
    else sleep();
  };
  for (const host of document.querySelectorAll('[data-cg-ink-host]')) {
    // A question's summary is the focus target; a guide row is focused through its link.
    host.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') fuzz(host); });
    host.addEventListener('pointerleave', () => { if (fuzzing === host) fuzz(null); });
    host.addEventListener('focusin', () => { if (host.matches(':focus-visible, :has(:focus-visible)')) fuzz(host); });
    host.addEventListener('focusout', () => { if (fuzzing === host) fuzz(null); });
  }

  reduce.addEventListener('change', () => {
    if (reduce.matches) {
      fuzz(null);
      document.documentElement.removeAttribute('data-cg-ink');
      sleep();
    } else {
      document.documentElement.setAttribute('data-cg-ink', '');
      lastBoil = lastFuzz = 0;
      wake();
    }
  });

  window.CollectorsGuildInk = { tune, fuzz, snapshot: () => ({ icons: document.querySelectorAll('.cg-ink-boil').length, targets: targets.length, onScreen: seen.size, running: !!frame, reduced: reduce.matches, step, fuzzing: fuzzing ? fuzzing.className : null, boilScale: boilMap.getAttribute('scale'), fuzzScale: fuzzMap.getAttribute('scale') }) };
})();
